import React, { createRef, useState, useEffect } from "react";
import "./MapWrapper.css";
import ModalComponent from "../ModalComponent/ModalComponent";
import { Expand, DownlaodNew } from "../../IconComponents";
import { downLoadScreenShot } from "../utils";
import { MapPin, Building } from "lucide-react";
import CustomMapBranch from "../CustomMap/CustomMapBranch";

// Removed LeafletMap component as we'll rely on CustomMapBranch instead

const MapWrapperBranch = (props) => {
  const {
    title, //string
    dropdownOptions, //array
    selectedOption, //string
    onChangeHandler, //function
    containerStyles = {}, //object
    headerStyles = {}, //object
    bodyStyles = {}, //object
    coordinates, // array of location objects
    chooseCoordinates,
    closeMapModal,
    zoom = 13,
    popUpShow = true,
    showBranchMarkers = false, // Flag to indicate if we should differentiate markers
  } = props;
  
  const [longitude, setLongitude] = useState("");
  const [latitude, setLatitude] = useState("");
  
  const chooseCoordinates1 = (longitude, latitude) => {
    setLongitude(longitude);
    setLatitude(latitude);
  };

  useEffect(() => {
    if (chooseCoordinates && longitude && latitude) {
      chooseCoordinates(longitude, latitude);
    }
  }, [longitude, latitude, chooseCoordinates]);

  const ref = createRef();
  const [showExpand, setShowExpand] = useState(false);
  const expandHandler = () => {
    setShowExpand(!showExpand);
  };

  const renderLegend = () => {
    if (!showBranchMarkers) return null;
    
    return (
      <div style={{
        position: 'absolute',
        bottom: '10px',
        right: '10px',
        backgroundColor: 'white',
        padding: '5px 10px',
        borderRadius: '4px',
        boxShadow: '0 1px 5px rgba(0,0,0,0.2)',
        zIndex: 1000,
        fontSize: '12px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
          <div style={{ 
            backgroundColor: '#e90e0e', 
            width: '12px', 
            height: '12px', 
            borderRadius: '50%',
            marginRight: '5px'
          }}></div>
          <span>Bank</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ 
            backgroundColor: '#FFA100', 
            width: '12px', 
            height: '12px', 
            borderRadius: '50%',
            marginRight: '5px'
          }}></div>
          <span>Branch</span>
        </div>
      </div>
    );
  };

  const renderMap = () => {
    // Always use CustomMapBranch instead of conditionally checking
    return (
      <CustomMapBranch 
        coordinates={coordinates}
        zoom={zoom}
        chooseCoordinates={chooseCoordinates1} 
        closeMapModal={closeMapModal} 
        popUpShow={popUpShow}
        showBranchMarkers={showBranchMarkers} 
        {...props}
      />
    );
  };

  return (
    <div className="map__container" style={{...containerStyles, position: 'relative'}}>
      <div className="map__container--header" style={{
        ...headerStyles,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          {title && <span className="map__header--text">{title}</span>}
        </div>
        
        <div style={{ 
          display: "flex", 
          alignItems: "center", 
          gap: "8px",
          marginLeft: "auto" 
        }}>
          <div className="map__container--export">
            <div className="map__container--export--icon cursor-pointer">
              {/* Expand/Download icons can go here if needed */}
            </div>
          </div>
          
          {/* Device Type dropdown if needed */}
          {onChangeHandler && dropdownOptions && (
            <div style={{ 
              display: "flex", 
              alignItems: "center", 
              marginLeft: "10px" 
            }}>
              <label style={{ 
                fontSize: "12px", 
                marginRight: "6px", 
                color: headerStyles.color || "white",
                whiteSpace: "nowrap"
              }}>
                Device Type:
              </label>
              <select
                className="category__select"
                style={{
                  backgroundColor: "transparent",
                  color: headerStyles.color || "white",
                  border: `1px solid ${headerStyles.color || "white"}`,
                  borderRadius: "4px",
                  padding: "3px 24px 3px 6px",
                  fontWeight: "normal",
                  fontSize: "12px",
                  width: "auto",
                  minWidth: "100px",
                }}
                onChange={onChangeHandler}
                value={selectedOption}>
                {dropdownOptions?.length > 0 &&
                  dropdownOptions.map((item, index) => (
                    <option
                      data-set={item?.id}
                      key={index}
                      value={item?.id}
                      className="option-text">
                      {item.value}
                    </option>
                  ))}
              </select>
            </div>
          )}
        </div>
      </div>

      <div className="map__container--body" ref={ref} style={bodyStyles}>
        {renderMap()}
        {showBranchMarkers && renderLegend()}
      </div>

      {showExpand && (
        <ModalComponent
          title="Map View"
          show={showExpand}
          handleToggle={expandHandler}
          fullscreen={true}
          component={renderMap()}
        />
      )}
    </div>
  );
};

export default MapWrapperBranch;